import {
    SIGNIN_DROPDOWN_TEXT,
    VARIANT_LOGINSIGNUP,
} from './experiments';
import {
    MY_ACCOUNT_TEXT,
    LOGIN_SIGNUP_TEXT,
} from './constants';

export function sanitizeId(id) {
    if (id) {
        return id.replace(/_.*$/, '').replace('-', '');
    }
}

const isSignInDropdownTextLoginSignup = ({ ab }) => {
    return ab[SIGNIN_DROPDOWN_TEXT.experimentId] === VARIANT_LOGINSIGNUP;
};
export const getSignInDropdownText = prop => {
    return isSignInDropdownTextLoginSignup(prop) ? LOGIN_SIGNUP_TEXT : MY_ACCOUNT_TEXT;
};
